import { Component, HostListener, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-go-to-top',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './go-to-top.html',
  styleUrls: ['./go-to-top.css']
})
export class GoToTopComponent implements OnInit {
  isVisible = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    // Check initial scroll position only in browser
    if (isPlatformBrowser(this.platformId)) {
      this.onWindowScroll();
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    // Only run in browser environment
    if (isPlatformBrowser(this.platformId)) {
      this.isVisible = window.pageYOffset > 300;
    }
  }

  scrollToTop(): void {
    // Only run in browser environment
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
